import { render, staticRenderFns } from "./TentUpdate.vue?vue&type=template&id=16ad6f4c&scoped=true"
import script from "./TentUpdate.vue?vue&type=script&lang=ts"
export * from "./TentUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad6f4c",
  null
  
)

export default component.exports